"use client"; // This ensures all code runs only on the client side

// Safely access localStorage only in browser environment
const getToken = () => {
  if (typeof window !== "undefined") {
    return localStorage.getItem("token");
  }
  return null;
};

// Safely remove token only in browser environment
const logout = () => {
  if (typeof window !== "undefined") {
    localStorage.removeItem("token");
    // Optional: Clear other user-related data
    localStorage.removeItem("userData");
  }
};

// Get current user with safe localStorage access
const getCurrentUser = () => {
  const token = getToken();
  if (!token) return null;

  try {
    const decodedToken = parseJwt(token);
    return decodedToken;
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};

// JWT parsing function with error handling
const parseJwt = (token) => {
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("Failed to parse JWT:", error);
    return null;
  }
};

// Additional utility functions
const setAuthToken = (token) => {
  if (typeof window !== "undefined") {
    localStorage.setItem("token", token);
  }
};

const isAuthenticated = () => {
  return !!getToken();
};

export default {
  logout,
  getCurrentUser,
  parseJwt,
  setAuthToken,
  isAuthenticated,
  getToken,
};